import { type MutableRefObject, type Ref, useCallback, useRef } from "react";

const isMutableRefObject = <T>(ref: Ref<T>): ref is MutableRefObject<T | null> => {
  return typeof ref === "object" && ref !== null && "current" in ref;
};

export const useCombinedRefs = <T>(...refs: Array<Ref<T> | undefined>) => {
  const refsRef = useRef(refs);
  refsRef.current = refs;

  return useCallback((element: T) => {
    for (let i = 0; i < refsRef.current.length; i++) {
      const ref = refsRef.current[i];
      if (!ref) continue;
      if (typeof ref === "function") {
        ref(element);
      } else if (isMutableRefObject(ref)) {
        ref.current = element;
      }
    }
  }, []);
};
